import { useState } from "react";
import { Modal, Spinner } from "reactstrap";
import "./style.scss";
const PillModal = ({
    trigger,
		fetchQuantity,
		loading,
		data,
		error,
		view,
		variant
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const toggle = () => setIsOpen(!isOpen);

	const handleOpen = (e) => {
			e.stopPropagation();
			fetchQuantity();
			toggle();
	};

	const handleOpenDetail = (id) => {
		if (!variant) return;
		if (variant === "Sections") {
			window.open(`/section?id=${id}`, "_blank");
		}
		if (variant === "Snippets") {
			window.open(`/snippet?id=${id}`, "_blank");
		}
	}

	return (
		<>
			<div onClick={handleOpen}>
					{trigger}
			</div>

			<Modal size="lg" centered={true} isOpen={isOpen} toggle={toggle}>
				<div className="pill-modal__header">
					<h5 className="pill-modal__header__title">{`${variant} related to this ${view}`}</h5>
				</div>
				<div className="pill-modal__body">
					{loading && (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ height: "200px", width: "100%" }}
            >
              <Spinner color="primary" style={{ height: "5rem", width: "5rem" }} />
            </div>
          )}
					{
						!loading && data?.length > 0 ? (
							<ul className="pill-modal__body__list">
								{data.map((item, i) => (
									<li 
										className={`pill-modal__body__list__item ${variant !== "Products" ? "is-hoverable" : ""}`} 
										key={i}
										onClick={ variant !== "Products" ? () => handleOpenDetail(item.id) : undefined}
										style={{ cursor: variant !== "Products" ? "pointer" : "default" }}
										>
										{variant !== "Products" ? item.title : item}
									</li>
								))}
							</ul>
						) : (
							!loading && <div className="pill-modal__body__empty">
								<p className="text-center">{error ? `Error loading ${variant.toLowerCase()}` : `No ${variant.toLowerCase()} found`}</p>
							</div>
						)
					}
				</div>
			</Modal>		
		</>
	);
};

export default PillModal;